<!-- eslint-disable max-len -->
<!-- eslint-disable vue/html-self-closing -->
<template>
  <section
    v-if="Object.keys(commit)?.length > 0"
    class="commit"
  >
    <div class="commit__header mb-3">
      <div class="commit__header-title mb-1">
        <h4 class="mb-0 text-truncate-l2">{{ commit?.shortMessage }}</h4>
        <button
          v-if="commit?.verificationResult"
          type="button"
          class="d-flex align-items-master px-2 border rounded bg-white"
          :style="gpgCommitInfo.elemStyle"
          :data-target="'commitGpgInfoModalWindow-' + commit?.hash"
        >
          <span class="d-none d-md-inline-block">
            {{ gpgCommitInfo.text }}
          </span>
          <span class="d-md-none">
            <i class="gf-icon" :class="gpgCommitInfo.icon"></i>
          </span>
        </button>
      </div>
      <div class="commit__header-actions">
        <gf-dropdown
          position="right"
          btn-class="btn btn-sm btn-outline-secondary ml-auto"
          btn-text="Дополнительно"
        >
          <a
            v-if="getActionAvailabilityFlag(ACTION_ENUM.MANAGE_TAG_API)"
            class="dropdown-item"
            :href="`/project/${alias}/${projectAlias}/tag/create?commitId=${commitId}`"
          >
            {{ $t('commit.tag.create') }}
          </a>
          <button
            v-if="getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD)"
            class="dropdown-item"
            type="button"
            @click="startCommitPipeline"
          >
            {{ $t('commit.pipeline.start') }}
          </button>
          <button
            v-if="getActionAvailabilityFlag(ACTION_ENUM.PUSH)"
            class="dropdown-item"
            type="button"
            @click="openCherryPickModal"
          >
            Cherry-pick
          </button>
        </gf-dropdown>
      </div>
    </div>
    <div class="commit__body">
      <div
        v-if="commit?.message"
        class="commit__body-message px-4 py-2"
      >
        <span>{{ commit?.message }}</span>
      </div>
      <hr class="w-100 my-1" />
      <div class="commit__body-commit ml-2">
        <div class="commit__body-commit-commiter">
          <div>
            <span>{{ $t('commit.author') }}</span>
            <img
              height="20px"
              width="20px"
              :src="commit.user ? commit.user?.avatar : commit?.authorIdent?.avatar"
              class="rounded-circle mx-1"
            />
            <a
              v-if="commit.user"
              :href="'/user/' + commit.user?.username"
              class="text-dark"
            >
              {{ commit.user?.fullName }}
            </a>
            <b v-else>{{ commit.authorIdent?.name }}</b>
          </div>
          <div>
            <span>{{ $t('commit.commiter') }}</span>
            <img
              height="20px"
              width="20px"
              :src="commit.user ? commit.user?.avatar : commit.committerIdent?.avatar"
              class="rounded-circle mx-1"
            />
            <a
              v-if="commit.user"
              :href="'/user/' + commit.user?.username"
              class="text-dark"
            >
              {{ commit.user?.fullName }}
            </a>
            <b v-else>{{ commit.committerIdent?.name }}</b>
          </div>
          {{ $moment.utc(commit.createdAt).fromNow() }}
        </div>
        <div class="commit__body-commit-commiter-statistics">
          <gf-diff-statistics
            v-if="Object.keys(commitCompareInfo)?.length > 0"
            :added-lines-number="commitCompareInfo.addedLinesInAllFiles"
            :removed-lines-number="commitCompareInfo.removedLinesInAllFiles"
            :changed-files-number="commitCompareInfo.commitBlobModelList?.length"
          />
          <gf-copy-commit-hash
            v-if="commit?.hash"
            :text="commit?.hash?.slice(0, 7)"
            :text-to-copy="commit?.hash"
          />
        </div>
      </div>
      <div class="commit__body-commit-relations">
        <div class="commit__body-commit-relations-parent py-2 px-4">
          <span>
            <i class="gf-icon gf-icon-dot mr-2"></i>
            Родители
          </span>
          <router-link
            v-for="parentCommit in commitCompareInfo.parentCommitIds"
            :key="parentCommit"
            tag="a"
            :to="{ params: { commitId: parentCommit } }"
          >
            {{ parentCommit?.slice(0, 7) }}
          </router-link>
          <router-link
            v-for="parentBranch in commitCompareInfo.parentCommitBranches"
            :key="parentBranch"
            class="badge badge-info text-truncate"
            tag="a"
            :to="{ name: 'commits-list', query: { branch: parentBranch } }"
          >
            {{ parentBranch }}
          </router-link>
        </div>
        <div
          v-if="commitCompareInfo?.pipelineId"
          class="commit__body-commit-relations-pipeline py-2 px-4"
        >
          <span>
            <i class="gf-icon gf-icon-rocket mr-2"></i>
            Последний конвейер
          </span>
          <a
            :href="`/project/${alias}/${projectAlias}/ci-cd/pipeline/${commitCompareInfo.pipelineId}`"
          >
            #{{ commitCompareInfo.pipelineId }}
          </a>
        </div>
      </div>
      <div class="commit__body-commit-diffs">
        <commit-diff-list
          v-if="
            Object.keys(commitCompareInfo)?.length > 0 && commitCompareInfo?.commitBlobModelList
          "
          :file-list="commitCompareInfo.commitBlobModelList"
          :project-alias="projectAlias"
          :alias="alias"
          :commit-id="commitId"
          :has-menu="true"
        />
        <packman-loader
          v-else
          :style="{ top: '50%' }"
        />
      </div>
    </div>
    <gf-custom-modal-window
      v-if="commit?.verificationResult"
      :gf-modal-data-name="'commitGpgInfoModalWindow-' + commit?.hash"
      :gf-modal-header="$t('commit.gpg.title')"
      gf-modal-wrapper-width="500px"
    >
      <template #body>
        <div>
          <p>
            {{ $t('commit.gpg.status') }}:
            {{ gpgCommitInfo.text }}
          </p>
          <p v-if="commit?.verificationResult?.comment">
            {{ $t('commit.gpg.reason.title') }}:
            <span v-if="commit?.verificationResult?.comment === 'no.public.key.found'">
              {{ $t('commit.gpg.reason.noPublicKeyFound') }}
            </span>
            <span v-else-if="commit?.verificationResult?.comment === 'key.expired'">
              {{ $t('commit.gpg.reason.keyExpired') }}
            </span>
            <span
              v-else-if="
                commit?.verificationResult?.comment === 'commiter.signature.emails.not.match'
              "
            >
              {{ $t('commit.gpg.reason.commiterSignaatureEmailsNotMatch') }}
            </span>
            <span v-else-if="commit?.verificationResult?.comment === 'other'">
              {{ $t('commit.gpg.reason.other') }}
            </span>
          </p>
          <p v-if="commit?.verificationResult?.keyId">
            {{ $t('commit.gpg.id') }}: {{ commit?.verificationResult?.keyId }}
          </p>
        </div>
      </template>
    </gf-custom-modal-window>
    <gf-custom-modal-window
      ref="gfModalWindowCherryPick"
      gf-modal-data-name="cherryPickModal"
      gf-modal-header="Cherry-pick"
      gf-modal-wrapper-width="500px"
      @close="resetErrors"
    >
      <template #body>
        <project-cherry-pick-form
          @cancel="closeCherryPickModal"
          @submit="createCherryPick"
        />
      </template>
    </gf-custom-modal-window>
  </section>
  <section
    v-else
    class="commit"
  >
    <packman-loader :style="{ top: '50%' }" />
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import GfCustomModalWindow from '@shared/shared-components/shared/GfCustomModalWindow';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import qs from 'qs';
import commitService from '@/shared-modules/modules/commit/commit.service';
import GfCopyCommitHash from '@/shared-modules/shared-components/shared/GfCopyCommitHash';
import GfDiffStatistics from '@/shared-modules/shared-components/commit-diff/GfDiffStatistics';
import ciCdService from '@/shared-modules/modules/ci-cd/ci-cd.service';
import packmanLoader from '@/shared-modules/shared-components/shared/packman-loader';
import CommitMessages from '@/shared-modules/modules/commit/commit.messages';
import GfDropdown from '@/shared-modules/shared-components/shared/GfDropdown';
// eslint-disable-next-line max-len
import ProjectCherryPickForm from '@/shared-modules/modules/commit/components/project-cherry-pick-form';
import { messageNotification } from '@/shared-modules/services/gf.notification.service';

export default {
  name: 'PageCommit',
  components: {
    GfCopyCommitHash,
    GfDiffStatistics,
    packmanLoader,
    GfDropdown,
    GfCustomModalWindow,
    ProjectCherryPickForm
  },
  data() {
    return {
      commit: {},
      commitCompareInfo: {}
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    alias() {
      return this.$route?.params?.alias;
    },
    projectAlias() {
      return this.$route?.params?.projectAlias;
    },
    commitId() {
      return this.$route?.params?.commitId;
    },
    projectUuid() {
      return this.$store.getters.getProjectUuid;
    },
    gpgCommitInfo() {
      return this.commit.verificationResult.expired
          ? {
              elemStyle:
                  'color: var(--gpg-key-expired-color); border: 1px solid var(--gpg-key-expired-color)',
              icon: 'gf-icon-history',
              text: this.$t('commit.gpg.expired')
            }
          : this.commit.verificationResult.verified
          ? {
            elemStyle: 'color: var(--success); border: 1px solid var(--success);',
            icon: 'gf-icon-check',
            text: this.$t('commit.gpg.verified')
          }
          : {
            elemStyle: 'color: var(--orange); border: 1px solid var(--orange);',
            icon: 'gf-icon-alert',
            text: this.$t('commit.gpg.unverified')
          };
    }
  },
  watch: {
    $route() {
      this.getCommitInfo();
      this.getCommitCompareInfo();
    }
  },
  mounted() {
    this.getCommitInfo();
    this.getCommitCompareInfo();
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    getCommitInfo() {
      commitService.getCommit(this.alias, this.projectAlias, this.commitId).then((res) => {
        this.commit = res;
      });
    },
    getCommitCompareInfo() {
      commitService
        .getCommitCompareInfo(this.alias, this.projectAlias, this.commitId)
        .then((res) => {
          this.commitCompareInfo = res;
        });
    },
    createCherryPick(data) {
      commitService
        .createCherryPick(this.alias, this.projectAlias, data.selectedBranch?.alias, {
          commitHash: this.commit?.hash,
          newBranch: data.startMergeRequest ? data.newBranchName : null
        })
        .then(() => {
          this.closeCherryPickModal();
          let encodedParams = {};
          if (data.startMergeRequest) {
            encodedParams = qs.stringify({
              compare: data.newBranchName,
              sourceProjectId: this.projectUuid,
              base: data.selectedBranch?.alias
            });
            window.location.href = `/project/${this.alias}/${this.projectAlias}/merge-request/create?${encodedParams}`;
          } else {
            encodedParams = qs.stringify({
              branch: data.selectedBranch?.alias
            });
            window.location.href = `/project/${this.alias}/${this.projectAlias}/commit?${encodedParams}`;
          }
        })
        .catch((err) => {
          if (err?.response?.data?.status === 409) {
            this.closeCherryPickModal();
            messageNotification('danger', {
              message: this.$t('commit.cherryPick.hasConflicts'),
              hasTimer: false
            });
          }
        });
    },
    startCommitPipeline() {
      ciCdService.startCommitPipeline(this.alias, this.projectAlias, this.commitId);
    },
    openCherryPickModal() {
      this.$refs.gfModalWindowCherryPick.openModalWindow();
    },
    closeCherryPickModal() {
      this.$refs.gfModalWindowCherryPick.closeModalWindow();
    },
    resetErrors() {
      this.$store.dispatch('setFormErrors', {
        formName: FORM_NAME_ENUMS.CHERRY_PICK_FORM,
        errorResponse: null
      });
    }
  },
  i18n: {
    messages: CommitMessages
  }
};
</script>

<style lang="scss">
$this: '.commit';

#{$this} {
  position: relative;
  min-height: 100px;

  #{$this}__header {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: flex-start;

    @media screen and (max-width: 767px) {
      flex-direction: column;
      flex-wrap: wrap;
    }

    &-title {
      display: flex;
      gap: 8px;
      align-items: center;

      & > button {
        height: fit-content;
      }
    }
    &-actions {
      display: flex;
      gap: 4px;

      & * {
        text-wrap: nowrap;
        height: fit-content;
      }

      @media (max-width: 767px) {
        flex-direction: column;
        width: 100%;
      }
    }
  }
  #{$this}__body {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &-message {
      background-color: var(--light);
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-lg);
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
    &-commit {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
      align-items: center;

      &-commiter {
        display: flex;
        gap: 8px;
        flex-grow: 1;

        &-statistics {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
      }
      &-relations {
        background-color: var(--light);
        border: 1px solid var(--border-color);
        border-radius: var(--border-radius);
        & div {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        &-pipeline {
          border-top: 1px solid var(--border-color);
        }
      }
      &-diffs {
        position: relative;
        min-height: 100px;
      }
    }
  }
}
</style>
